/**
 * 与 SidebarMenu 中「Claw 历史会话」Tab 一致：这些路径下侧栏展示 Claw WS 会话列表，
 * 搜索也应按 clawSessions 本地过滤，而非对话搜索 API。
 */
export const CLAW_SIDEBAR_HISTORY_PATH_BASES = [
  '/claw',
  '/mainagent',
  '/skills',
  '/lab',
  '/agents',
] as const;

export function isClawSidebarHistoryPath(pathname: string): boolean {
  return CLAW_SIDEBAR_HISTORY_PATH_BASES.some(
    (base) => pathname === base || pathname.startsWith(`${base}/`),
  );
}
